import { AdCardIndexSet } from "~/components/story-style/story-style-layout/consts";

export type ArticleCardState = {
  articleCardIndex: number;
  currentState: "default" | "isCurrentIndexFromPreviousCard" | "isCurrentIndexFromNextCard";
};

export const initialArticleCardState: ArticleCardState = {
  articleCardIndex: 0,
  currentState: "default",
};

export type GetArticleCardInfoActionTypeParameters = {
  currentIndex: number;
  hasAdCards?: boolean;
  updateType: "decrease" | "increase";
};

type ArticleCardActionType =
  | "decreaseToAdCard"
  | "decreaseToArticleCard"
  | "increaseToAdCard"
  | "increaseToArticleCard";

export function getArticleCardInfoActionType(
  parameters: GetArticleCardInfoActionTypeParameters,
): ArticleCardActionType {
  const { currentIndex, hasAdCards, updateType } = parameters;
  const updatedArticleIndexWithoutAd =
    updateType === "increase" ? currentIndex + 1 : currentIndex - 1;
  const isUpdatedCardAdCard = hasAdCards && AdCardIndexSet.has(updatedArticleIndexWithoutAd);
  if (isUpdatedCardAdCard) {
    return updateType === "increase" ? "increaseToAdCard" : "decreaseToAdCard";
  }

  return updateType === "increase" ? "increaseToArticleCard" : "decreaseToArticleCard";
}

type ArticleCardAction = {
  type: ArticleCardActionType;
};

export function articleCardInfoReducer(
  state: ArticleCardState,
  action: ArticleCardAction,
): ArticleCardState {
  switch (action.type) {
    case "decreaseToAdCard":
      return {
        articleCardIndex: state.articleCardIndex,
        currentState: "isCurrentIndexFromNextCard",
      };
    case "decreaseToArticleCard":
      return {
        articleCardIndex:
          state.currentState === "isCurrentIndexFromPreviousCard"
            ? state.articleCardIndex
            : state.articleCardIndex - 1,
        currentState: "default",
      };
    case "increaseToAdCard":
      return {
        articleCardIndex: state.articleCardIndex,
        currentState: "isCurrentIndexFromPreviousCard",
      };
    case "increaseToArticleCard":
      return {
        articleCardIndex:
          state.currentState === "isCurrentIndexFromNextCard"
            ? state.articleCardIndex
            : state.articleCardIndex + 1,
        currentState: "default",
      };
  }
}
